import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import Type from '@nerdwallet/react-typography';
import Button from '@nerdwallet/react-button';
import Image from '@nerdwallet/react-image';
import { useImpression } from '@nerdwallet/analytics/react/impression';

const SmorgasbordTile = ({
  backgroundColor,
  textColor,
  entityName,
  eyebrow,
  eyebrowColor,
  description,
  descriptionImage,
  descriptionItalic,
  buttonText,
  buttonUrl,
  buttonColor,
  quoteText,
  quoteColor,
  quoteSize,
  imageUrl,
  imageAlt,
  index,
  boxUrl,
  imageLinkUrl,
}) => {
  const tileWrapper = {
    backgroundColor: backgroundColor && `${backgroundColor}`,
    color: textColor && `${textColor}`,
  };

  const buttonBackground = {
    backgroundColor: buttonColor && `${buttonColor}`,
  };

  const { ref } = useImpression({
    eventType: 'element_impression',
    entityName,
    payload: {
      element_position: index - 1,
      section_name: 'smorgasboard_guides',
    },
  });

  return (
    <div
      ref={ref}
      style={tileWrapper}
      className={classNames([
        'smorga__tile',
        classes('margin-right-3'),
        classes('margin-right-0--wide'),
        classes('border-radius-1'),
      ])}
    >
      {boxUrl ? (
        <a href={imageLinkUrl} className="smorga_tile__link">
          <div
            className={classNames([
              'smorga__content',
              classes('padding-vertical-5'),
              classes('margin-horizontal-5'),
              classes('padding-vertical-5--wide'),
              classes('padding-horizontal-0--wide'),
              classes('display-flex'),
              classes('flex-direction-column'),
              classes('justify-content-center'),
              classes('height-100'),
            ])}
          >
            {eyebrow && (
              <Type
                color={eyebrowColor}
                uppercase
                size="1"
                bold
                className={classNames([
                  'smorga__eyebrow',
                  classes('margin-bottom-3'),
                ])}
              >
                {eyebrow}
              </Type>
            )}
            {description && (
              <Type
                gotham
                size="3"
                color={textColor}
                className={classNames(['smorga__description'])}
              >
                {description}
              </Type>
            )}
            {descriptionImage && (
              <Type
                gotham
                size="2"
                color={textColor}
                className={classNames(['smorga__image-description'])}
              >
                {descriptionImage}
              </Type>
            )}
            {descriptionItalic && (
              <Type
                gotham
                size="3"
                color={textColor}
                italic
                className={classNames(['smorga__description'])}
              >
                {descriptionItalic}
              </Type>
            )}
            {quoteText && (
              <Type
                gotham
                size={quoteSize}
                bold
                color={quoteColor}
                className={classNames([
                  'smorga__quote',
                  classes('margin-vertical-3'),
                ])}
              >
                {quoteText}
              </Type>
            )}
            {imageUrl && (
              <Image
                src={imageUrl}
                alt={imageAlt}
                naturalHeight={158}
                naturalWidth={392}
                backgroundColor="transparent"
                imageClassName={classNames([
                  'smorga__image',
                  classes('margin-top-4'),
                  classes('margin-all-0--wide'),
                ])}
              />
            )}
          </div>
        </a>
      ) : (
        <div
          className={classNames([
            'smorga__content',
            classes('padding-vertical-5'),
            classes('margin-horizontal-5'),
            classes('padding-vertical-0--wide'),
            classes('display-flex'),
            classes('flex-direction-column'),
            classes('justify-content-center'),
            classes('height-100'),
          ])}
        >
          {eyebrow && (
            <Type
              color={eyebrowColor}
              uppercase
              size="1"
              bold
              className={classNames([
                'smorga__eyebrow',
                classes('margin-bottom-3'),
              ])}
            >
              {eyebrow}
            </Type>
          )}
          {description && (
            <Type
              gotham
              size="3"
              color={textColor}
              className={classNames(['smorga__description'])}
            >
              {description}
            </Type>
          )}
          {descriptionImage && (
            <Type
              gotham
              size="2"
              color={textColor}
              className={classNames(['smorga__image-description'])}
            >
              {descriptionImage}
            </Type>
          )}
          {descriptionItalic && (
            <Type
              gotham
              size="3"
              color={textColor}
              italic
              className={classNames(['smorga__description'])}
            >
              {descriptionItalic}
            </Type>
          )}
          {quoteText && (
            <Type
              gotham
              size={quoteSize}
              bold
              color={quoteColor}
              className={classNames(['smorga__quote', classes('margin-top-3')])}
            >
              {quoteText}
            </Type>
          )}
          {imageUrl && (
            <a href={buttonUrl}>
              <Image
                src={imageUrl}
                alt={imageAlt}
                naturalHeight={158}
                naturalWidth={392}
                backgroundColor="transparent"
                imageClassName={classNames([
                  'smorga__image',
                  classes('margin-top-4'),
                ])}
              />
            </a>
          )}
          {buttonText && (
            <div>
              <Button
                href={buttonUrl}
                style={buttonBackground}
                className={classNames(['smorga__btn', classes('margin-top-4')])}
              >
                {buttonText}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

SmorgasbordTile.propTypes = {
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  entityName: PropTypes.string,
  eyebrow: PropTypes.string,
  eyebrowColor: PropTypes.string,
  description: PropTypes.string,
  descriptionImage: PropTypes.string,
  descriptionItalic: PropTypes.string,
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string,
  buttonColor: PropTypes.string,
  quoteText: PropTypes.string,
  quoteColor: PropTypes.string,
  quoteSize: PropTypes.string,
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  index: PropTypes.number,
  boxUrl: PropTypes.bool,
  imageLinkUrl: PropTypes.string,
};

SmorgasbordTile.displayName = 'SmorgasbordTile';

export default SmorgasbordTile;
